<template>
  <section class="app-main">
    <el-row :gutter="10">
      <el-col :xs="24" :sm="7" :lg="6" :xl="6">
        <div class="aside" style="margin-right:0;border:1px solid #eee;">
          <Menu></Menu>
          <!-- <div>
            <biaoqian></biaoqian>
          </div> -->
        </div>
      </el-col>
      <el-col :xs="24" :sm="17" :lg="18" :xl="18">
        <div class="contentlist" style="float:left;margin-left:0;border:1px solid #eee;width:99%;">
          <shiyanListG ></shiyanListG>
        </div>
      </el-col>
    </el-row>
    <div id="notice"  v-if="this.noticeState == 1">
        <span class="svg-containerN">
          <svg-icon icon-class="NotificatonOnButton" />
        </span>
        <div class="notice-title">
           <span :title="this.noticeTitle">{{this.noticeTitle}}</span>
        </div>
    </div>
    <div id="el-main-footer">
      <div class="info">
        <span>© 2020 上海矩道网络科技有限公司</span>
        <span> ⋅ </span>
        <a href="http://www.beian.miit.gov.cn" target="_blank">沪ICP备16019102号</a>
        <span> ⋅ </span>
        <span>商务QQ:3235186608</span>
        <span> ⋅ </span>
        <span>产品QQ:3512883254</span>
      </div>
    </div>
  </section>
</template>

<script>
import request from '@/utils/request'
import shiyanListG from '@/components/myComponentsM/shiyanListG'
import Menu from '@/components/myComponentsM/Menu'
export default {
  data(){
    return{
      noticeState:'',
      noticeTitle:'',
    }
  },
  components:{
    Menu,shiyanListG
  },
  computed: {},
  created(){
    this.shwoNotice();
  },
  methods:{
    shwoNotice(){
      request({
        method:'get',
        url:'api/notice/tokentrue'
      }).then(res=>{
        if(res.data == null){
          this.noticeState = 0
        }else{
          this.noticeState = res.data[0].state
          this.noticeTitle = res.data[0].content
        }
      })
    },
  },
  beforeRouteLeave(to, from, next) {
    from.meta.keepAlive = false;
    next();
  },
}
</script>

<style scoped>
  @import './notice.css';
  #el-main-footer{
    background:none repeat scroll 0 0 white;
    border-top:1px solid #e7eaec;
    overflow:hidden;
    font-size:0.7rem !important;
    color:#7a8b9a;
    letter-spacing:0.8px;
    font-family:Arial, sans-serif !important;
    position: fixed;
    bottom: 0;
    height: 32px;
    z-index:1000;
    width: 100%;
  }
  .info{
    position: absolute;
    top: 50%;
    left: 6px;
    transform: translateY(-50%);
  }
  .aside, .contentlist{
    margin: 73px 10px 30px 10px;
    background-color: #fff;
  }
  .app-main {
    /*84 = navbar + tags-view = 50 +34 */
    min-height: calc(100vh - 84px);
    width: 100%;
    position: relative;
    overflow: hidden;
  }
  @media (max-width:1024px) {
    .aside{
      margin-left: 5px !important;
    }
  }
  @media screen and (min-width:1025px) and (max-width:1366px){
    .contentlist{
      margin: 73px 10px 30px 10px;
      margin-left:5px !important;
    }
  }
  @media screen and (min-width:1366px) and (max-width:1440px){
  }
  @media screen and (min-width:1441px) and (max-width:1600px){
  }
  @media screen and (min-width:1601px) and (max-width:1920px){
  }
  @media screen and (min-width:1921px) and (max-width:2048px){
  }
  @media (min-width:2049px){
    #el-main-footer{
      height: 60px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/layout/components/AppMainM.vue